import React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgPlusClockCounterClockwiseOffsetIcon = ({
  color,
  alt,
  "aria-roledescription":
    roleDescription = "Counter-clockwise clock with a plus in the corner",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <g clipPath="url(#clip0_24662_258439)">
      <path
        d="M10 6.25V10L13.125 11.875"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 8.125H2.5V5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.28125 15C6.26404 15.9274 7.49832 16.5446 8.82987 16.7745C10.1614 17.0044 11.5312 16.8368 12.768 16.2927M16.8739 9.90004C16.8543 8.54893 16.437 7.23355 15.6741 6.11825C14.9112 5.00295 13.8366 4.13719 12.5845 3.62914C11.3324 3.1211 9.9583 2.99329 8.63397 3.26169C7.30964 3.5301 6.09377 4.18281 5.13828 5.13828C4.21875 6.06953 3.45938 6.94766 2.5 8.125"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_24662_258439)">
        <path
          d="M14.1992 13.9375H18.9258"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5625 11.5742V16.3008"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_24662_258439">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_24662_258439">
        <rect
          width="6.875"
          height="6.875"
          fill="white"
          transform="translate(13.125 10.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const PlusClockCounterClockwiseOffsetIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgPlusClockCounterClockwiseOffsetIcon />
  </BaseIcon>
);

export default PlusClockCounterClockwiseOffsetIcon;
